export class BaseModel<T extends object = any> {
    static primaryKey = "id"

    constructor(data: Partial<T> = {}) {
        Object.assign(this, data)
    }

    get primaryKey(): string {
        return (this.constructor as typeof BaseModel).primaryKey
    }

    get primaryKeyValue(): unknown {
        return (this as any)[this.primaryKey]
    }

    static fromData<U extends object>(
        this: new (data?: Partial<U>) => BaseModel<U>,
        data: Partial<U>,
    ): BaseModel<U> {
        return new this(data)
    }
}
